import(/* webpackMode: "eager" */ "/vercel/path0/src/app/events/[id]/page.tsx");
